import { render, staticRenderFns } from "./modalEditSocialMilestone.vue?vue&type=template&id=e605d844&"
import script from "./modalEditSocialMilestone.vue?vue&type=script&lang=js&"
export * from "./modalEditSocialMilestone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports